import { Obscura } from '../../vendor';

import InboomaBaseAsyncCollection from './InboomaBaseAsyncCollection'
import SalesBilling from '../models/SalesBilling'

const SalesBillingsProxy = Obscura.extend({
    getFilterCount () {
        return this.getFilters().length
    }
});

export default InboomaBaseAsyncCollection.extend({
        collectionName: 'salesBillings',
        model: SalesBilling,
        url: '/sales_billings',
        proxy : SalesBillingsProxy,

        _pagination: {
            // Updated after each request (response.pagination)
            current_page: 0,
            sort: 'date',
            sortDirection: 'desc',
            has_next_page: false,
            has_prev_page: false,
            count: 0, // not relevant; response total entities count
            limit: 500
        },
    });

